import React from 'react';
import { Button, ModalBody, ModalFooter, ModalNext, Icon } from '@jutro/components';
import { GridItem } from '@jutro/layout';

function AdacConfirmationModal({
    isOpen,
    onResolve,
    onReject,
    onAfterClose,
    message,
    confirmButtonText,
    icon
}) {

    function handleConfirm() {
        return onResolve();
    }

    function handleClose() {
        return onReject();
    }

    return (
        <ModalNext
            isOpen={isOpen}
            onRequestClose={handleClose}
            onAfterClose={onAfterClose}
        >
            <Icon
                icon={icon || 'mi-check-circle'}
                size="small"
                className="modalCheckIcon"
            />
            <ModalBody
                contentLayout={{
                    component: 'Grid',
                    componentProps: {
                        columns: ['1fr'],
                    },
                }}
                autoFocus
            >
                <GridItem>
                    <h3 Style="color: var(--ADAC-BLACK); text-align: center">{message}</h3>
                </GridItem>
            </ModalBody>
            <ModalFooter>
                <Button
                    id="closeBtn"
                    type="outlined"
                    onClick={handleConfirm}
                    aria-label={confirmButtonText}
                    fullWidth
                >
                    {confirmButtonText}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

export default AdacConfirmationModal;